import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { config } from './config';

@Feature()
export class InsertLayoutFeature extends BaseToolbarFeature {
    public id = config.id;
    public currentPageChangeReaction;
    public toolbarService;

    public get curModelIsLayout(): boolean {
        return !!this.getSelectionService().currentSlide?.isLayout;
    }

    public get curModelIsMaster(): boolean {
        return !!this.getSelectionService().currentSlide?.isMaster;
    }

    /**
     * 插入一个版式
     * @param type
     * @param aExtraProps
     */
    public insertLayout = () => {
        if (!this.getSelectionService().currentSlide) return;

        const layoutModel = this.getSelectionService().currentSlide;
        const presentation = layoutModel?.presentationRef;
        presentation?.addLayout();

        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.MASTER,
            action: TDWActionType.INSERT_LAYOUT,
        });
    };
}
